module.exports = __webpack_public_path__ + "img/hiking008.005ebf5e.jpg";